import { render } from "./ServiceTile.vue?vue&type=template&id=51d9d4bd&scoped=true&ts=true"
import script from "./ServiceTile.vue?vue&type=script&lang=ts"
export * from "./ServiceTile.vue?vue&type=script&lang=ts"

import "./ServiceTile.vue?vue&type=style&index=0&id=51d9d4bd&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d9d4bd"]])

export default __exports__